import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO} from "@app/constants/Common";
import MailBodyEditorContent from "@pages/email/common/view/MailBodyEditorContent";
import {requestGetInviteJobMailTemps} from "@app/services/InviteJobMailTemplateService";
import {MailTempType} from "@pages/email/common/Constant";
import Select from "react-select";

const FullMailChooseYourSignatures = (props) => {
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [yourSignatureOptions, setYourSignatureOptions] = useState([]);
    const [selectedSignature, setSelectedSignature] = useState();
    const [signatureContent, setSignatureContent] = useState("");

    const {content, onChange} = props

    const fetchYourEmailSignatureTemps = async () => {
        const res = await requestGetInviteJobMailTemps({search_conditions: {unlimited: true, template_type: MailTempType.SIGNATURE}});
        const signatureList = res.content.mail_templates
        const signatureOptionList = []
        signatureList.forEach(item => {
            signatureOptionList.push({value: item.id, label: item.name, content: item.signature_body})
        })
        setYourSignatureOptions([...signatureOptionList]);
    }

    useEffect(() => {
        const strUserLogin = localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)
        if (!userLoginInfo.id && strUserLogin) {
            const userLogin = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
            setUserLoginInfo(userLogin)

            fetchYourEmailSignatureTemps(userLogin.id)
        }
    }, [])

    useEffect(() => {
        if (content) {
            setSignatureContent(content)
        }

    }, [content])

    const onChangeSelectSigTemp = (selectTemp) => {
        console.log("onChangeSelectSigTemp")
        setSelectedSignature({...selectTemp})
        setSignatureContent(selectTemp.content)
        onChange(selectTemp.content)
    }

    const onChangeContent = (changeContent) => {
        console.log("onChangeContent")
        onChange(changeContent)
    }

    return (
        <>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title'><b>Chữ ký</b></h3>

                    <div className={'float-right col-sm-6 p-0'}>
                        <Select options={yourSignatureOptions}
                                styles={{
                                    // Fixes the overlapping problem of the component
                                    menu: provided => ({ ...provided, zIndex: 9999 })
                                }}
                                value={selectedSignature}
                                name={"selectedSignature"}
                                placeholder={'Chọn temp chữ ký...'}
                                onChange={temp => {
                                    onChangeSelectSigTemp(temp);
                                }}
                        />
                    </div>
                </div>
                <div className='card-body p-0'>
                    <MailBodyEditorContent
                        name={"full-mail-signature-temp"}
                        onChange={(values) => onChangeContent(values)}
                        content={signatureContent}/>
                </div>
            </div>
        </>
    )
}

export default FullMailChooseYourSignatures;
